//
//
//
//
//
//
//
//
//
//
//

import MiniPlayer from '@/components/music_player/MiniPlayer.vue'
import { mapMutations } from 'vuex'

export default {
  name: "WorkAudioPostItem",
  created() {},
  props: ["post"],
  data() {
    return {};
  },
  computed: {
    audioUrl: function() {
      return this.post.get("compressedAudio")
        ? this.post.get("compressedAudio").get("url")
        : this.post.get("audio").get("url");
    }
  },
  methods: {
    ...mapMutations(['setAudioMsg']),
    // 播放音频时添加信息
    onClickMiniPlayer (item) {
      this.setAudioMsg(item)
    },

    goToUserMsg () {
      this.$router.push({
        name: 'userMsg',
        params: {
          userId: this.post.get('user').id
        }
      })
    }
  },
  components: {
    MiniPlayer
  }
};



// WEBPACK FOOTER //
// ./src/components/post_item/WorkAudioPostItem.vue